import { environment } from "src/environments/environment";
import { BRANDING } from "./branding.constants";

export const STEALTH_SUPPORT = {
    TOLL_FREE_NUMBER: BRANDING.PHONE_NUMBER,
    TOLL_FREE_OPTION: BRANDING.TOLL_FREE_OPTION,
    EMAIL: BRANDING.SUPPORT_EMAIL,
    ADDRESS: BRANDING.ADDRESS
}

export const TIMEZONES: { [key: string]: string } = {
    "Dateline Standard Time": "Etc/GMT+12",
    "UTC-11": "Etc/GMT+11",
    "Aleutian Standard Time": "America/Adak",
    "Hawaiian Standard Time": "Pacific/Honolulu",
    "Marquesas Standard Time": "Pacific/Marquesas",
    "Alaskan Standard Time": "America/Anchorage",
    "UTC-09": "Etc/GMT+9",
    "Pacific Standard Time (Mexico)": "America/Tijuana",
    "UTC-08": "Etc/GMT+8",
    "Pacific Standard Time": "America/Los_Angeles",
    "US Mountain Standard Time": "America/Phoenix",
    "Mountain Standard Time (Mexico)": "America/Chihuahua",
    "Mountain Standard Time": "America/Denver",
    "Central America Standard Time": "America/Guatemala",
    "Central Standard Time": "America/Chicago",
    "Easter Island Standard Time": "Pacific/Easter",
    "Central Standard Time (Mexico)": "America/Mexico_City",
    "Canada Central Standard Time": "America/Regina",
    "SA Pacific Standard Time": "America/Bogota",
    "Eastern Standard Time (Mexico)": "America/Cancun",
    "Eastern Standard Time": "America/New_York",
    "Haiti Standard Time": "America/Port-au-Prince",
    "Cuba Standard Time": "America/Havana",
    "US Eastern Standard Time": "America/Indianapolis",
    "Turks And Caicos Standard Time": "America/Grand_Turk",
    "Paraguay Standard Time": "America/Asuncion",
    "Atlantic Standard Time": "America/Halifax",
    "Venezuela Standard Time": "America/Caracas",
    "Central Brazilian Standard Time": "America/Cuiaba",
    "SA Western Standard Time": "America/La_Paz",
    "Pacific SA Standard Time": "America/Santiago",
    "Newfoundland Standard Time": "America/St_Johns",
    "Tocantins Standard Time": "America/Araguaina",
    "E. South America Standard Time": "America/Sao_Paulo",
    "SA Eastern Standard Time": "America/Cayenne",
    "Argentina Standard Time": "America/Buenos_Aires",
    "Greenland Standard Time": "America/Godthab",
    "Montevideo Standard Time": "America/Montevideo",
    "Magallanes Standard Time": "America/Punta_Arenas",
    "Saint Pierre Standard Time": "America/Miquelon",
    "Bahia Standard Time": "America/Bahia",
    "UTC-02": "Etc/GMT+2",
    "Azores Standard Time": "Atlantic/Azores",
    "Cape Verde Standard Time": "Atlantic/Cape_Verde",
    "UTC": "Etc/UTC",
    "GMT Standard Time": "Europe/London",
    "Greenwich Standard Time": "Atlantic/Reykjavik",
    "Sao Tome Standard Time": "Africa/Sao_Tome",
    "Morocco Standard Time": "Africa/Casablanca",
    "W. Europe Standard Time": "Europe/Berlin",
    "Central Europe Standard Time": "Europe/Budapest",
    "Romance Standard Time": "Europe/Paris",
    "Central European Standard Time": "Europe/Warsaw",
    "W. Central Africa Standard Time": "Africa/Lagos",
    "Jordan Standard Time": "Asia/Amman",
    "GTB Standard Time": "Europe/Bucharest",
    "Middle East Standard Time": "Asia/Beirut",
    "Egypt Standard Time": "Africa/Cairo",
    "E. Europe Standard Time": "Europe/Chisinau",
    "Syria Standard Time": "Asia/Damascus",
    "West Bank Standard Time": "Asia/Hebron",
    "South Africa Standard Time": "Africa/Johannesburg",
    "FLE Standard Time": "Europe/Kiev",
    "Turkey Standard Time": "Europe/Istanbul",
    "Israel Standard Time": "Asia/Jerusalem",
    "Kaliningrad Standard Time": "Europe/Kaliningrad",
    "Libya Standard Time": "Africa/Tripoli",
    "Arabic Standard Time": "Asia/Baghdad",
    "Arab Standard Time": "Asia/Riyadh",
    "Belarus Standard Time": "Europe/Minsk",
    "Russian Standard Time": "Europe/Moscow",
    "E. Africa Standard Time": "Africa/Nairobi",
    "Iran Standard Time": "Asia/Tehran",
    "Arabian Standard Time": "Asia/Dubai",
    "Astrakhan Standard Time": "Europe/Astrakhan",
    "Azerbaijan Standard Time": "Asia/Baku",
    "Russia Time Zone 3": "Europe/Samara",
    "Mauritius Standard Time": "Indian/Mauritius",
    "Saratov Standard Time": "Europe/Saratov",
    "Georgian Standard Time": "Asia/Tbilisi",
    "Caucasus Standard Time": "Asia/Yerevan",
    "Afghanistan Standard Time": "Asia/Kabul",
    "West Asia Standard Time": "Asia/Tashkent",
    "Yekaterinburg Standard Time": "Asia/Yekaterinburg",
    "Pakistan Standard Time": "Asia/Karachi",
    "India Standard Time": "Asia/Kolkata",
    "Sri Lanka Standard Time": "Asia/Colombo",
    "Nepal Standard Time": "Asia/Kathmandu",
    "Central Asia Standard Time": "Asia/Almaty",
    "Bangladesh Standard Time": "Asia/Dhaka",
    "Omsk Standard Time": "Asia/Omsk",
    "Myanmar Standard Time": "Asia/Yangon",
    "SE Asia Standard Time": "Asia/Bangkok",
    "Altai Standard Time": "Asia/Barnaul",
    "W. Mongolia Standard Time": "Asia/Hovd",
    "North Asia Standard Time": "Asia/Krasnoyarsk",
    "N. Central Asia Standard Time": "Asia/Novosibirsk",
    "Tomsk Standard Time": "Asia/Tomsk",
    "China Standard Time": "Asia/Shanghai",
    "North Asia East Standard Time": "Asia/Irkutsk",
    "Singapore Standard Time": "Asia/Singapore",
    "W. Australia Standard Time": "Australia/Perth",
    "Taipei Standard Time": "Asia/Taipei",
    "Ulaanbaatar Standard Time": "Asia/Ulaanbaatar",
    "North Korea Standard Time": "Asia/Pyongyang",
    "Tokyo Standard Time": "Asia/Tokyo",
    "Korea Standard Time": "Asia/Seoul",
    "Yakutsk Standard Time": "Asia/Yakutsk",
    "Cen. Australia Standard Time": "Australia/Adelaide",
    "AUS Central Standard Time": "Australia/Darwin",
    "E. Australia Standard Time": "Australia/Brisbane",
    "AUS Eastern Standard Time": "Australia/Sydney",
    "West Pacific Standard Time": "Pacific/Port_Moresby",
    "Tasmania Standard Time": "Australia/Hobart",
    "Vladivostok Standard Time": "Asia/Vladivostok",
    "Russia Time Zone 10": "Asia/Sakhalin",
    "Magadan Standard Time": "Asia/Magadan",
    "Sakhalin Standard Time": "Asia/Sakhalin",
    "Russia Time Zone 11": "Asia/Kamchatka",
    "Central Pacific Standard Time": "Pacific/Guadalcanal",
    "Norfolk Standard Time": "Pacific/Norfolk",
    "Samoa Standard Time": "Pacific/Apia",
    "Line Islands Standard Time": "Pacific/Kiritimati",
    "Tonga Standard Time": "Pacific/Tongatapu"
};

export enum ACTION {
    ADD = 'add',
    REMOVE = 'remove'
}

export const EmailLogo = {
    STEALTH_LOGO : 'https://stgdevopsinfra.blob.core.windows.net/image/Stealth%20Monitoring%20Logo%20Medium.png',
    ECAM_LOGO : 'https://uiapps.blob.core.windows.net/emailresources/ecam_logo.png'
}

export const EcamTitle = BRANDING.COMPANY_NAME;

export const DOMAIN_OKTA_CONFIGURATION = [
  {
    name: 'sewell',
    issuer: environment.okta.sewell.issuer,
    audience: environment.okta.sewell.audience,
    domains: environment.okta.sewell.domains.split(',').map((domain: string) => domain.trim()),
  },
  {
    name: 'ecam',
    issuer: environment.okta.ecam.issuer,
    audience: environment.okta.ecam.audience,
    domains: environment.okta.ecam.domains.split(',').map((domain: string) => domain.trim()),
  }
];

export const DOMAIN_MICROSOFT_CONFIGURATION = [
  {
    name: 'ups',
    issuer: environment.microsoft.ups.issuer,
    audience: environment.microsoft.ups.audience,
    domains: environment.microsoft.ups.domains.split(',').map((domain: string) => domain.trim()),
    azureRedirectUrl: environment.microsoft.ups.azureRedirectUrl,
  },
  {
    name: 'genericMicrosoft',
    issuer: environment.microsoft.genericMicrosoft.issuer,
    audience: environment.microsoft.genericMicrosoft.audience,
    domains: environment.microsoft.genericMicrosoft.domains.split(',').map((domain: string) => domain.trim()),
    azureRedirectUrl: environment.microsoft.genericMicrosoft.azureRedirectUrl,
  }
];

export const TIMELAPSE_BUFFER_CONFIG = [
  { clipLength: 30, targetBufferSeconds: 15 },
  { clipLength: 60, targetBufferSeconds: 15 },
  { clipLength: 90, targetBufferSeconds: 15 },
  { clipLength: 120, targetBufferSeconds: 15 },
  { clipLength: 150, targetBufferSeconds: 15 },
  { clipLength: 180, targetBufferSeconds: 15 }
];

export const TIMELAPSE_CONSTANTS = {
  TIME_RANGE_OPTIONS: [
    'Last 24 Hours', 
    'Last 48 Hours', 
    'First Image to Latest Image', 
    'Custom Date'
  ],
  
  CLIP_LENGTH_OPTIONS: [
    { label: '30 seconds', seconds: 30 },
    { label: '1 minute', seconds: 60 },
    { label: '1 minute 30 seconds', seconds: 90 },
    { label: '2 minutes', seconds: 120 },
    { label: '2 minutes 30 seconds', seconds: 150 },
    { label: '3 minutes', seconds: 180 }
  ],

  DEFAULT_FPS: 20,
  DEFAULT_CLIP_LENGTH_SECONDS: 30,
  API_MAX_RESULT_COUNT: 500,
  TOKEN_SOFT_EXPIRY_MS: 15 * 60 * 1000, // 15 minutes
  TOKEN_HARD_EXPIRY_MS: 30 * 60 * 1000, // 30 minutes
};

// After hour Schedule
export const MAX_SHORT_TERM_DURATION_DAYS = 7;
